import React, { useState } from 'react';
import { message, Button, Upload } from 'antd';
import { UploadOutlined, StarOutlined } from '@ant-design/icons';
import type { UploadChangeParam } from 'antd/es/upload';
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface';

type PropsType = {
	action?: any;
	name?: any;
	value?: any;
	onChange?: any;
	fileName?: string;
	fileType?: string;
	fileSize?: number;
};

// TODO:repeat code
const SPUploadSingleFile: React.FC<PropsType> = props => {
	const { onChange, value, fileName, fileType, fileSize } = props;

	const getName: any = (url: any) => {
		try {
			return decodeURIComponent(url.split('name=')[1]);
		} catch (e) {
			return fileName || '文件';
		}
	};

	const beforeUpload = (file: RcFile) => {
		let isType = false;

		if (fileType) {
			if (fileType === 'excel') {
				isType =
					file.type === 'application/vnd.ms-excel' ||
					file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
			} else {
				const fileTypeLength = fileType.split('').length
				isType = file.type === `application/${fileType}` || file.name.slice(0 - fileTypeLength) === fileType;
			}
		} else {
			isType = file.type === 'application/pdf';
		}

		if (!isType) {
			message.error(`仅支持${fileType || 'PDF'}格式!`);
		}
		const isLt2M = file.size / 1024 / 1024 < (fileSize || 5);
		if (!isLt2M) {
			message.error(`文件需小于${fileSize || 5}MB!`);
		}

		if (!isType || !isLt2M) return Upload.LIST_IGNORE;
	};

	const initFileList = (val: any) => {
		let list: any = [];

		if (val) list.push({ uid: val, name: getName(val), url: val, status: 'done', response: { data: val } });

		return list;
	};

	const [myFileList, setMyFileList] = useState<UploadFile[]>(initFileList(value));

	const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
		// 格式：[{status: 'done'}, {status: 'done'}]
		setMyFileList(newFileList);

		// 都上传完毕，没有uploading
		if (newFileList.find((f: any) => f.status != 'done') == undefined) {
			let errFile = newFileList.find((f: any) => f?.response?.data == null);

			if (errFile) message.error(errFile?.response?.msg || errFile?.response?.errmsg);

			let list = newFileList.filter((f: any) => f?.response?.data != null);

			setMyFileList(list);

			// 格式：[url, url, url]
			//onChange(list.map((f: any) => f?.response?.data))
			// 格式：url
			onChange(list.length > 0 ? list[0].response.data : '');
		}
	};

	return (
		<Upload
			name="file"
			// headers={{ authorization: 'authorization-text' }}
			maxCount={1}
			beforeUpload={beforeUpload}
			action={props?.action}
			onChange={handleChange}
			fileList={myFileList}
			showUploadList={{
				showRemoveIcon: true,
				removeIcon: '删除',
			}}
		>
			<Button icon={<UploadOutlined />}>上传</Button>
		</Upload>
	);
};

export default SPUploadSingleFile;
